import { render, staticRenderFns } from "./SquotationUpdate.vue?vue&type=template&id=542767b0&scoped=true"
import script from "./SquotationUpdate.vue?vue&type=script&lang=js"
export * from "./SquotationUpdate.vue?vue&type=script&lang=js"
import style0 from "./SquotationUpdate.vue?vue&type=style&index=0&id=542767b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542767b0",
  null
  
)

export default component.exports